import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import IconSync from "@material-ui/icons/Sync";

import SyncDialog from "./SyncDialog";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing.unit * 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    button: {
      margin: theme.spacing.unit,
      minWidth: 200,
    },
    icon: {
      marginRight: theme.spacing.unit,
    },
  });

type SyncMasterProps = {} & WithStyles<typeof styles>;

const SyncMasterUnstyled: React.SFC<SyncMasterProps> = (props) => {
  const { classes } = props;

  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);

  const handleSync = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <div className={classes.root}>
      <Button variant="contained" color="primary" size="large" onClick={handleSync} disabled={dialogOpen} className={classes.button}>
        <IconSync className={classes.icon} />
        Sync
      </Button>

      <SyncDialog open={dialogOpen} onClose={handleClose} />
    </div>
  );
};

export default withStyles(styles)(SyncMasterUnstyled);
